<div fxLayout="row" fxLayoutAlign="start center">
    <h4 class="ms-2 font-size-14" fxFlex>Trip Mirror Map</h4>
    <button mat-icon-button color="accent" (click)="close()">
        <mat-icon>clear</mat-icon>
    </button>
</div>

<div class="map-card">
    <div id="map"></div>
</div>
